<template>
    <div class="settleCount" id="charge-info">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1">&nbsp;</div>
                <div style="height:89.3%;position:relative;overflow:hidden;">
                    <div class="searchBox flex flex-align-center">
                        <div class="searchCon clearfix">
                            <div class="date-filter" v-if="nowType=='MONTH'">
                                <span>选择时间:</span>
                                <el-date-picker v-model="dateStr" type="month" ref='dateInput' value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="请选择选择日期">
                                </el-date-picker>
                                <span style="margin-left:20px;">交易时间：{{nowSettleInfo.begin | dateForGradePage}} 至 </span>
                                <span>{{nowSettleInfo.end | dateForGradePage}}</span>
                            </div>
                            <div class="time-range-filter" v-if="nowType=='TIME_RANGE'">
                                <span>起始时间:</span>
                                <el-date-picker
                                v-model="startTime"
                                type="datetime"
                                class="dateTime"
                                default-time="00:00:00"
                                :picker-options="pickerOptions"
                                placeholder="开始时间">
                                </el-date-picker>
                                <span>至</span>
                                <el-date-picker
                                v-model="endTime"
                                type="datetime"
                                class="dateTime"
                                default-time="23:59:59"
                                :picker-options="pickerOptions"
                                placeholder="结束时间">
                                </el-date-picker>
                                <!-- <span class="phone">电话号码:
                                    <el-input
                                    placeholder="请输入会员手机号码"
                                    v-model="searchPhone"
                                    clearable>
                                    </el-input>
                                </span> -->
                                <!-- <span class="filter-tit">当班员工:</span>
                                <el-select v-model="empMobile"  placeholder="请选择" class="new-inp">
                                    <el-option
                                    :key="0"
                                    :label="'全部'"
                                    :value="'ALL'">
                                    </el-option>
                                    <el-option
                                    v-for="item in emps"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.mobile">
                                    </el-option>
                                </el-select> -->
                                <span class="types typesSearch" >
                                    <span type="button" @click="searchConfirm">查询</span>
                                </span>
                            </div>
                            <!--  -->
                            <!-- <div class="type-change" @click="nowType=='MONTH'?nowType='TIME_RANGE':nowType='MONTH'">
                                <span>{{nowType=='MONTH'?'按时间段查询':'按月查询'}}</span>
                            </div> -->
                            <!-- <button v-if="nowType=='MONTH'" class="do-search" @click="doSearch">查询</button> -->
                        </div>
                    </div>
                    <div class="HSpace2">&nbsp;</div>
                    <div class="panle">
                        <div class="panle-item">
                            <span class="item-name">
                                <i class="iconfont icon-jine"></i>
                                <span>交易净额</span>
                            </span>
                            <span class="item-val">￥{{Number(nowSettleInfo.amount).toFixed(2)}}</span>
                        </div>
                        <div class="panle-item">
                            <span class="item-name">
                                <i class="iconfont icon-daishoujine"></i>
                                <span>支付手续费</span>
                            </span>
                            <span class="item-val">￥{{Number(Number(nowSettleInfo.amount)*fee).toFixed(2)}}</span>
                        </div>
                    </div>
                    <div class="panle">
                        <div class="panle-item flex-all">
                            <span class="item-name">
                                <i class="iconfont icon-jine1"></i>
                                <span>结算金额</span>
                            </span>
                            <span class="item-val">￥{{Number(Number(nowSettleInfo.amount)*(1-fee)).toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="pagination">
                    <div class="res-info left">
                        <span class="item">充值笔数:<span class="num"> {{totalChargeCount}} 笔 </span></span>
                        <span class="item">充值金额:<span class="num"> {{totalChargeAmount.toFixed(2)}} 元 </span></span>
                        <span class="item">赠送金额:<span class="num"> {{totalBonusAmount.toFixed(2)}} 元 </span></span>
                    </div>
                    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
                    </el-pagination>
                </div> -->
                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left">1</span>
                                <span class="next flex flex-align-center flex-pack-center left havePage"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right">第 1 / 9 条</div>
                        <div class="totalPage flex flex-align-center right">共100条</div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import cartInfo from "./../../../cartInfo/cartInfo";
    export default{
        props: ['curStoreId','pageSize'],
        components:{cartInfo},
        data () {
            return {
                fee:0.004,
                lastExTime:"",
                nowSelMobile:'',
                nowSelName:'',
                empMobile:"ALL",
                emps:[],
                totalBonusAmount:0,
                totalChargeAmount:0,
                totalChargeCount:0,
                nowExcInfo:{},//当前查看详情的会员信息
                showCartInfo:false,
                stateInfo:{
                   "DEPOSIT":"储值",
                   "WITHDRAW":"消费",
                   "REFUND":"退款",
                },
                exchangeList: [], // 核销详情
                nowType:"MONTH",
                startTime:'',//按时间段查询的起始时间
                endTime:'',//按时间段查询的结束时间
                pickerOptions: {
                    disabledDate(time) {
                        let date = new Date();
                        let month = date.getMonth();
                        return time.getMonth() >= month;
                    }
                },
                dateStr: "",
                currentPage: 1,
                totalElements: 0, //数据总条数
                canClick:true,
                searchPhone:"",//会员搜索手机号
                nowSettleInfo:{
                    amount:0,
                    begin:"",
                    end:""
                },
            }
        },
        watch: {
            dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM"));
            let nowDate = new Date(val).Format("yyyy-MM");
            this.dateStr = nowDate;
            this.getSettleInfo(nowDate);
            },
            showCartInfo(val){
                if(!val){
                    this.nowSelMobile = "";
                    this.nowSelName = "";
                    this.nowExcInfo = {};
                }
            }
        },
        methods: {
            getSettleInfo(nowDate){
                this.$http({
                    url:"get-online",
                    method:"GET",
                    params:{
                        time:`${nowDate}-09 00:00:00`,
                        storeId:this.curStoreId
                    }
                }).then(res=>{
                    console.log(res);
                    if(res.data.code == 200){
                        this.nowSettleInfo = res.data.data;
                    }else{
                        this.$message({
                            message: "暂无数据",
                            customClass: 'error'
                        })
                        return;
                    }
                })
            },
            getEmps(){
                this.$http({
                    url:"employees",
                    method:"GET",
                    params:{
                    storeId:this.curStoreId,
                    enabled:true,
                    }
                }).then(res=>{
                    this.emps = res.data;
                })
            },
            showExcInfo(item){
                let beginTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                let endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                this.nowSelMobile = item.mobile;
                this.nowSelName = item.name;
                this.$http({
                    url:"workshift/choose/details",
                    method:"GET",
                    params:{
                        mobile:item.mobile,
                        begin:beginTime,
                        end:endTime,
                        storeId:this.curStoreId
                    }
                }).then(res=>{
                    // if(res.data.code == 200){
                        this.nowExcInfo = res.data;
                        setTimeout(()=>{
                            this.showCartInfo = true;
                        },300);
                    // }
                })
            },
            doSearch(){
                if(this.canClick){
                    this.canClick = false;
                    this.getChargeInfo(0,this.dateStr);
                }
            },
            //分页方法
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                console.log(this.dateStr);
                this.getChargeInfo(val - 1, this.dateStr,"MONTH");
                // if(this.nowType == "MONTH"){
                //     this.getChargeInfo(val - 1, this.dateStr,"MONTH");
                // }else{
                //     this.getChargeInfo(val - 1, this.dateStr,"ARB");
                // }
            },
            // 搜索
            searchConfirm: function () {
                if(((new Date(this.endTime)).getTime() - (new Date(this.startTime)).getTime()) > 1000*60*60*24*35){
                        this.$message({
                            message: '只能查询35天内的数据',
                            customClass: 'error'
                        })
                        return;
                }
                
                if(this.startTime!=='' && this.endTime!==''){
                    if(new Date(this.startTime)>new Date(this.endTime)){
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        })
                        return;
                    }
                    if( ((new Date(this.startTime)).getTime() > (new Date(this.lastExTime)).getTime()) || ((new Date(this.endTime)).getTime() > (new Date(this.lastExTime)).getTime()) ){
                        this.$message({
                            message: '当前选择时间无交班信息',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(this.canClick){
                        this.canClick = false;
                        this.getChargeInfo(0, this.dateStr,"ARB");
                    }
                }else{
                    this.$message({
                        message: '请选择查询时间段',
                        customClass: 'error'
                    })
                    return;
                }
            },
            // 获取核销详情
            getChargeInfo: function (page, date, type="MONTH") {
                let params;
                // if(this.empMobile){
                    // if(!/^(\d){11}$/.test(this.searchPhone)){
                    //     this.$message({
                    //         message: '手机号输入有误',
                    //         customClass: 'error'
                    //     })
                    //     setTimeout(()=>{
                    //         this.canClick = true;
                    //     },500);
                    //     return;
                    // }
                    let beginTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    let endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                    if(!this.startTime||this.startTime==""||!this.endTime||this.endTime==""){
                        this.$message({
                            message: '请选择时间',
                            customClass: 'error'
                        });
                        this.canClick = true;
                        return;
                    }
                    params = {
                        storeId:this.curStoreId,
                        begin:beginTime,
                        end:endTime,
                        // openMobile:this.empMobile
                    }
                // }else{
                //     let beginTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                //     let endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                //     params = {
                //         storeId:this.curStoreId,
                //         beginTime,
                //         endTime,
                //         openMobile:"ALL"
                //     }
                // }
                
                
                this.$http({
                    url:"get-emp",
                    method:"GET",
                    params
                }).then(res=>{
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                    console.log(res.data)
                    // return;
                    let body = res.data;
                    // if(body.code == 200){
                        this.exchangeList = body;
                        // this.totalChargeCount = body.data.totalCount;
                        // this.totalChargeAmount = body.data.totalAmount;
                        // this.totalBonusAmount = body.data.totalBonusAmount;
                        let number = this.pageSize - this.exchangeList.length;
                        // this.totalElements = body.data.totalElements;
                        if ( number > 0 ) {
                            for (let i = 0; i < number; i++) {
                                this.exchangeList.push({
                                    amount:"",
                                    mobile:"",
                                    name:""
                                });
                            }
                        }
                    // }else{
                    //     this.$message({
                    //         message: body.msg,
                    //         customClass: 'error'
                    //     });
                    // }
                }).catch((err) => {
                    setTimeout(()=>{
                        this.canClick = true;
                    },500);
                });
            },
            getLastExTime(){
                this.$http({
                    url:"get-endTime",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId
                    }
                }).then(res=>{
                    let date = new Date(res.data);
                    let time = date.Format("yyyy-MM-dd");
                    this.startTime = time+" 00:00:00";
                    this.endTime = date.Format("yyyy-MM-dd hh:mm:ss");
                    this.lastExTime = res.data;
                    // this.pickerOptions = {
                    //     disabledDate(time) {
                    //         return time.getTime() > new Date(res.data);
                    //     }
                    // }
                })
            }
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.exchangeList.push({
                    workShift:{
                        closeUsername:"",
                        beginTime:"",
                        endTime:"",
                        total:0
                    }
                })
            }
            // 获取员工列表
        },
        mounted(){
            this.getLastExTime();
        },
        activated: function () {
            this.getEmps();
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss" scoped>
    @import './../../../../../static/css/common.scss';
    @import './../../../tableTemplate/tableTem.scss';
    @import './../../../tableTemplate/el-dialog.scss';
    @import "./settleCount.scss";
</style>



// WEBPACK FOOTER //
// settleCount.vue?ba91596e